import React from "react";

import { usePathname } from "next/navigation";

const Color: React.FC = () => {
  const pathname = usePathname();

  if (pathname !== "/") return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-40 h-full w-full bg-gradient-to-t from-bg-dark to-transparent opacity-40" />
  );
};

export default Color;
